import { selectEntities, select } from './applicationSelectors';

const selectPartEntities = selectEntities('parts');
export const selectPart = select(selectPartEntities);
